module.exports = __webpack_public_path__ + "static/media/red-hook-homes.463fc725.jpeg";